export const getNewsletterFormUnavailableMessage = (country?: string, language?: string) => {
  switch (`${country}/${language}`) {
    case "ca/fr":
      return "L’inscription aux nouvelles et aux mises à jour est temporairement indisponible.";
    case "fr/fr":
      return "L’inscription aux actualités et aux mises à jour est temporairement indisponible.";
    case "de/de":
      return "Die Anmeldung für Neuigkeiten und Updates ist vorübergehend nicht verfügbar.";
    default:
      return "Signing up for news and updates is temporarily unavailable.";
  }
};
